import DateAdapter from '@src/utils/DateAdapter'
import UpdateEvaluacionAnualDto from '../../domain/UpdateEvaluacionAnualDto'
import { VUETIFY_DATE_FORMAT } from '@src/const'

class UpdateEvaluacionAnualAdapter {
  static toDto({ idPersonalEvaluador, estatus, fecha, reactivos, tipoEvaluacion }) {
    return UpdateEvaluacionAnualDto.create({
      fk_idPersonalEvaluador: idPersonalEvaluador,
      fecha: fecha,
      fk_idCatEstatusEvaluacion: estatus,
      cumplimientoFunciones: reactivos.map((reactivo) => ({
        id: reactivo.id,
        calificacion: String(Number(reactivo.calificacion)),
        fk_idDescripcionCriterio: reactivo.idDescripcionCriterio,
        estatus: true,
      })),
      fk_idCatTipoEvaluacion: tipoEvaluacion,
    })
  }
}

export default UpdateEvaluacionAnualAdapter
